module.exports = __webpack_public_path__ + "3f16e137/img/pdf-icon.79f04a36.svg";